export const ROLES = {
    HOST:      "host",
    MEMBER:    "member",    // invited/authenticated person
    GUEST:     "guest",     // anonymous/temporary person
    PRESENTER: "presenter", // when host gives permission to screenshare for guest
    BOT:       "bot",       // for beam recording/streaming
}
